
import { defineComponent, ref, Ref } from 'vue';
import FriendlyCaptcha from './vue-friendlycaptcha.vue';
import HCaptcha from './vue-hcaptcha.vue';

export default defineComponent({
  components: {
    FriendlyCaptcha,
    HCaptcha,
  },

  emits: ['captchaVerified'],

  props: {
    captchaKey: {
      type: String,
      required: true,
    },

    captchaType: {
      type: String,
      required: false,
    },

    locale: {
      type: String,
      required: false,
    },
  },

  setup() {
    const captchaVerified: Ref<string | null> = ref(null);
    const displayLoader = ref(false);
    return { captchaVerified, displayLoader };
  },

  mounted() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.displayLoader = false;
  },

  methods: {
    /**
     * Captcha
     */
    onCaptchaVerified(resp: string) {
      this.captchaVerified = resp || '';
      this.$emit('captchaVerified', this.captchaVerified);
      this.displayLoader = true;
    },

    onCaptchaError(resp: string) {
      console.log('Captcha error:', resp);
    },

    onCaptchaExpired(resp: string) {
      console.log('Captcha expired:', resp);
    },

    resetCaptcha() {
      this.displayLoader = false;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const fCaptcha = this.$refs.fCaptcha as any;
      fCaptcha.reset();
      fCaptcha.start(); // only for friendly
    },
  },

  computed: {
    captchaLocale() {
      return this.locale === 'en_GB' ? 'en' : this.locale;
    },
    isFriendly() {
      return this.captchaType?.toLowerCase() !== 'hcaptcha';
    },
  },
});
